const capitalze = string =>
    typeof string === 'string'
        ? string.charAt(0).toUpperCase() + string.substr(1).toLowerCase()
        : string;

export default capitalze;
